import { env } from '@/config/env';
import { BRAND } from '@/config/brand';
import { cn } from '@/utils/cn';

interface BrandLogoProps {
  /** Show product name beside the mark */
  showName?: boolean;
  /** Override display name (default: env.appName) */
  name?: string;
  /** Visual size preset */
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeMap = {
  sm: { img: 'h-8 max-w-[160px]', text: 'text-base' },
  md: { img: 'h-10 max-w-[200px]', text: 'text-lg' },
  lg: { img: 'h-12 max-w-[240px]', text: 'text-2xl' },
} as const;

export function BrandLogo({
  showName = true,
  name = env.appName,
  size = 'md',
  className,
}: BrandLogoProps) {
  const s = sizeMap[size];
  return (
    <div className={cn('flex min-w-0 items-center gap-2.5', className)}>
      <img
        src={BRAND.logoPath}
        alt=""
        className={cn('w-auto shrink-0 object-contain', s.img)}
        width={240}
        height={48}
      />
      {showName && (
        <span
          className={cn(
            'truncate font-bold tracking-tight text-primary-700 dark:text-primary-300',
            s.text,
          )}
        >
          {name}
        </span>
      )}
    </div>
  );
}
